/* eslint-disable react/destructuring-assignment */
/* eslint-enable jsx-a11y/accessible-emoji */

import React, { Component } from 'react';
import { v4 as uuidv4 } from 'uuid';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import { ToastContainer, toast } from 'react-toastify';

import callapi from '../services/callapi';
import { API_BASE_URL } from '../misc/config';
// import { SendEmail } from './sendEmail';
import { Pdfpreview } from './pdfPreview';
import { Footer } from './shareOnPlateform';
import { FullFooter } from './shareOnPlateformFullicon';
import { ReactComponent as PdfStatic } from '../static/thread-demo-image.svg';
import { ReactComponent as HeaderLogo } from '../static/ThreadMagic-Logo.svg';
import { ReactComponent as ConvertToPdf } from '../static/convert-pdf.svg';
import { ReactComponent as SendToPdf } from '../static/send-icon-pdf.svg';
import { ReactComponent as PowerdSocialPilot } from '../static/powerd-by.svg';
import { encrypt } from '../utils/encryptionDecryption';
import socket from '../services/socket';

import './commonstyle.scss';
import 'react-toastify/dist/ReactToastify.css';

export class Threadurl extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tweetUrl: '',
      tweetEmail: '',
      newError: '',
      showButton: false,
      addEmailComponent: false,
      pdfURLPreview: false,
      apiCall: false,
    };
  }

  // eslint-disable-next-line react/sort-comp
  handleURLChange = event => {
    event.preventDefault();
    this.setState({ tweetUrl: event.target.value });
    if (event.target.value) {
      this.setState({ showButton: true });
    }
    if (!event.target.value) {
      this.setState({ showButton: false });
    }
  };

  handleEmailChange = event => {
    event.preventDefault();
    this.setState({ tweetEmail: event.target.value });
    if (event.target.value) {
      this.setState({ showButton: true });
    }
    if (!event.target.value) {
      this.setState({ showButton: false });
    }
  };

  ConvertToPdf = async event => {
    event.preventDefault();
    const url = this.state.tweetUrl;
    const urlValid = new RegExp(/^https:\/\/twitter.com\//, 'gm');
    if (url && !url.match(urlValid)) {
      this.setState({ newError: 'This is not twitter url' });
      return;
    }
    if (url && url.split('https://twitter.com/')[1].split('/').length !== 3) {
      this.setState({ newError: 'Please Enter Proper URL' });
      return;
    }
    this.setState({ showButton: false });
    this.setState({ apiCall: true });
    const results = await callapi(
      `${API_BASE_URL}/threadBOT/generatePDF?url=${url}`,
      'get',
      'null',
    );
    if (results.data.status !== 200) {
      this.setState({ newError: results.data });
      return;
    }
    if (results.data.status === 200) {
      this.setState({ addEmailComponent: true });
    }
  };

  SendToPdf = async event => {
    event.preventDefault();
    const email = this.state.tweetEmail;
    // eslint-disable-next-line no-useless-escape
    const tester = /^[-!#$%&'*+\/0-9=?A-Z^_a-z{|}~](\.?[-!#$%&'*+\/0-9=?A-Z^_a-z`{|}~])*@[a-zA-Z0-9](-*\.?[a-zA-Z0-9])*\.[a-zA-Z](-?[a-zA-Z0-9])+$/;

    if (!tester.test(email)) {
      this.setState({
        newError: 'Please Provide Valid Email',
      });
      return;
    }
    const pdfURL = encrypt(`${localStorage.getItem('final')}.pdf`);
    const TweetURL = encrypt(this.state.tweetUrl);
    const results = await callapi(
      `${API_BASE_URL}/threadBOT/sendEmail`,
      'post',
      { email, oldURL: TweetURL, newURL: pdfURL },
    );
    if (results.data.status === 200) {
      this.setState({ showButton: false });
      toast.success('Thank Your Download PDF');
      setTimeout(() => {
        localStorage.clear();
        window.onbeforeunload = localStorage.clear();
        window.location.reload(1);
      }, 3000);
    }
  };

  componentDidMount() {
    const uniqueId = uuidv4();
    this.setState({ tweetUrl: '' });
    socket.on('connect', () => {
      try {
        socket.emit('join', uniqueId);
        localStorage.setItem('uniqueId', uniqueId);
      } catch (e) {
        // ignore
      }
    });

    socket.on('downloadPDF', msg => {
      const final = msg.data.response.pdfUrl;
      console.log('final-->', final);
      if (final) this.setState({ pdfURLPreview: true });
      localStorage.setItem('final', final);
    });
  }

  render() {
    const emailComponent = this.state.addEmailComponent;
    const buttonProperty = this.state.showButton;
    const errorMessage = this.state.newError;
    const pdfview = this.state.pdfURLPreview;
    const apiLoading = this.state.apiCall;
    return (
      <div className="container-fluid plain-container">
        <ToastContainer position="top-center" />
        {emailComponent ? (
          <div className="row h-100">
            <div className="col-lg-6 col-sm-6 d-flex align-items-center justify-content-center bg-white">
              <div className="middle-content">
                <div className="row">
                  <div className="col-lg-12">
                    <div className="header-twitter-thread-logo">
                      <HeaderLogo />
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-lg-12">
                    <div className="thread-title">
                      <h1>Rock 'n' roll.</h1>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-lg-12">
                    <div className="thread-description email-thread-description">
                      <p>
                        ThreadMagic has successfully transformed your Twitter
                        thread. Sign up with your email to receive your free,
                        ready-to-share copy.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-lg-12">
                    <form>
                      <input
                        type="text"
                        name="this.state.userid"
                        placeholder="Enter Your Email"
                        onChange={this.handleEmailChange}
                        value={this.state.tweetEmail}
                        className="form-control"
                      />
                      {errorMessage ? (
                        <span className="text-danger">{errorMessage}</span>
                      ) : (
                        <></>
                      )}

                      {buttonProperty ? (
                        <button
                          type="submit"
                          className="btn btn-green send-email-to-pdf  d-flex align-items-center justify-content-center"
                          onClick={this.SendToPdf}
                        >
                          <SendToPdf />
                          <span className="ml-2">Send Me on Email</span>
                        </button>
                      ) : (
                        <button
                          type="submit"
                          className="btn btn-green send-email-to-pdf  d-flex align-items-center justify-content-center"
                          disabled
                        >
                          <SendToPdf />
                          <span className="ml-2">Send Me on Email</span>
                        </button>
                      )}

                      {/* <button
                        type="submit"
                        className="btn btn-green send-email-to-pdf  d-flex align-items-center justify-content-center"
                        onClick={this.SendToPdf}
                        disabled={this.state.showButton}
                      >
                        <SendToPdf />
                        <span className="ml-2">Send Me on Email</span>
                      </button> */}
                      {/* <input type="submit" value="Convert to pdf" /> */}
                    </form>
                  </div>
                </div>
                <div className="row">
                  <div className="col-lg-12">
                    <div className="footer-social-media full-footer-social-media">
                      <FullFooter />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-6 col-sm-6 feature-image d-flex align-items-center justify-content-center blue-shade-bg">
              {pdfview ? (
                <Pdfpreview />
              ) : (
                <div className="react-pdf-withLoader">
                  <Box sx={{ display: 'flex' }}>
                    <CircularProgress />
                  </Box>
                </div>
              )}

              <div className="row">
                <div className="col-lg-12">
                  <div className="powerd-by">
                    <PowerdSocialPilot />
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div className="row h-100">
            <div className="col-lg-6 col-sm-6 d-flex align-items-center justify-content-center bg-white">
              <div className="middle-content">
                <div className="row">
                  <div className="col-lg-12">
                    <div className="header-twitter-thread-logo">
                      <HeaderLogo />
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-lg-12">
                    <div className="thread-title">
                      <h1>Be adored on LinkedIn</h1>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-lg-12">
                    <div className="thread-description">
                      <p>
                        Share awesome{' '}
                        <span role="img" aria-label="Raising Hand">
                          🙌
                        </span>{' '}
                        Twitter threads on LinkedIn using ThreadMagic and get
                        more engagement. ThreadMagic converts whole Twitter
                        threads into well-organized, carousel-style PDFs that
                        are ready to share.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-lg-12">
                    <form onSubmit={this.handleSubmit}>
                      <input
                        type="text"
                        name="this.state.userid"
                        placeholder="Paste your Twitter thread URL here"
                        onChange={this.handleURLChange}
                        value={this.state.tweetUrl}
                        className="form-control is-valid"
                      />
                      {errorMessage ? (
                        <span className="text-danger">{errorMessage}</span>
                      ) : (
                        <></>
                      )}
                      {buttonProperty ? (
                        <button
                          type="submit"
                          className="btn btn-primary convert-to-pdf d-flex align-items-center justify-content-center"
                          onClick={this.ConvertToPdf}
                        >
                          <ConvertToPdf />
                          <span className="ml-2">LET THE MAGIC BEGIN</span>
                        </button>
                      ) : (
                        <button
                          type="submit"
                          className="btn btn-primary convert-to-pdf d-flex align-items-center justify-content-center"
                          disabled
                        >
                          <ConvertToPdf />
                          <span className="ml-2">LET THE MAGIC BEGIN</span>
                        </button>
                      )}
                      <div>
                        {apiLoading ? (
                          <div className="react-pdf-withLoader">
                            <Box sx={{ display: 'flex' }}>
                              <CircularProgress />
                            </Box>
                          </div>
                        ) : (
                          <></>
                        )}
                      </div>
                      {/* <button
                        type="submit"
                        className="btn btn-primary convert-to-pdf d-flex align-items-center justify-content-center"
                      >
                        <ConvertToPdf />
                        <span className="ml-2">Convert to pdf</span>
                      </button> */}
                      {/* <input type="submit" value="Convert to pdf" /> */}
                    </form>
                  </div>
                </div>
                <div className="row">
                  <div className="col-lg-12">
                    <div className="footer-social-media">
                      <Footer />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-6 col-sm-6 feature-image d-flex align-items-center flex-column justify-content-center blue-shade-bg">
              <div className="row">
                <div className="col-lg-12">
                  <div className="pdf-static-viewer">
                    <PdfStatic />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-lg-12">
                  <div className="powerd-by powerd-by-static">
                    <PowerdSocialPilot />
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}
